import * as THREE from 'three'
import Experience from "../Experience";
import anim from '../Utils/Anim.js';

import Buildings from './assets/Buildings.js';
import Road from './assets/Road.js';
import vertexBody from '../../shaders/building/body/vertex.glsl'
import fragmentBody from '../../shaders/building/body/fragment.glsl'
import vertexVitre from '../../shaders/building/vitre/vertex.glsl'
import fragmentVitre from '../../shaders/building/vitre/fragment.glsl'
import vertexRoad from '../../shaders/road/vertex.glsl'
import fragmentRoad from '../../shaders/road/fragment.glsl'


export default class Tableau2 {
    constructor(_options) {
        this.experience = new Experience()
        this.scene = this.experience.scene
        this.ressources = this.experience.ressources
        this.time = this.experience.time
        // 
        this.isDestroyed = false
        this.targetPos = _options.targetPos
        this.newPos = new THREE.Vector3(this.targetPos.x, 0, 0)
        // renderer setup
        anim.to(this.experience.renderer.darkMaterial, { opacity: 1, duration: 1, })
        // 
        this.setMaterials()

        this.batiments = new Buildings({
            targetPos: this.newPos,
            materials: this.materials
        })
        this.road = new Road({
            targetPos: this.newPos,
            materials: this.materials

        })
        this.setDebug()



    }
    setMaterials() {

        // this.vitreMaterialblack = new THREE.MeshBasicMaterial({ color: 'black' })
        this.vitreMaterialblack = new THREE.ShaderMaterial({
            vertexShader: vertexVitre,
            fragmentShader: fragmentVitre,
            transparent: true,
            uniforms: {
                u_power: new THREE.Uniform(0),
                u_fog: new THREE.Uniform(0.8)
            }
        })
        // this.vitreMaterialwhite = new THREE.MeshBasicMaterial({ color: 'white' })
        this.vitreMaterialwhite = new THREE.ShaderMaterial({
            vertexShader: vertexVitre,
            fragmentShader: fragmentVitre,
            transparent: true,
            uniforms: {
                u_power: new THREE.Uniform(2),
                u_fog: new THREE.Uniform(0.8)
            }
        })
        this.bodyMaterial = new THREE.ShaderMaterial({
            vertexShader: vertexBody,
            fragmentShader: fragmentBody,
            transparent: true,
            uniforms: {
                u_fog: new THREE.Uniform(0.8)
                // u_fog: new THREE.Uniform(1.5)
            }
        })
        this.roadMaterial = new THREE.ShaderMaterial({
            vertexShader: vertexRoad,
            fragmentShader: fragmentRoad,
            transparent: true,
            uniforms: {
                u_fog: new THREE.Uniform(2.2),
                u_targetPos: new THREE.Uniform(new THREE.Vector3(0, 0, 0))
            }
        })
        this.bodyMaterial.uniforms.u_fog.value = -2
        this.vitreMaterialwhite.uniforms.u_fog.value = -2
        this.vitreMaterialblack.uniforms.u_fog.value = -2
        this.roadMaterial.uniforms.u_fog.value = -1

        anim.to(this.bodyMaterial.uniforms.u_fog, { value: 0.8, duration: 1 })
        anim.to(this.vitreMaterialwhite.uniforms.u_fog, { value: 0.8, duration: 1 })
        anim.to(this.vitreMaterialblack.uniforms.u_fog, { value: 0.8, duration: 1 })
        anim.to(this.roadMaterial.uniforms.u_fog, { value: 2.2, duration: 1 })

        this.materials = {
            road: this.roadMaterial,
            body: this.bodyMaterial,
            white: this.vitreMaterialwhite,
            black: this.vitreMaterialblack,
        }

    }




    setDebug() {
        if (this.experience.debug.active) {
            const ui = this.experience.debug.ui
            const buildingsFolder = ui.addFolder('buildings')
            buildingsFolder.add(this.bodyMaterial.uniforms.u_fog, 'value').min(-1).max(5).step(0.001).onChange((value) => {
                this.bodyMaterial.uniforms.u_fog.value = value
                this.vitreMaterialwhite.uniforms.u_fog.value = value
                this.vitreMaterialblack.uniforms.u_fog.value = value
                this.roadMaterial.uniforms.u_fog.value = value
            })

        }
    }
    destroy() {

        anim.to(this.bodyMaterial.uniforms.u_fog, { value: -2, duration: 1 })
        anim.to(this.vitreMaterialwhite.uniforms.u_fog, { value: -2, duration: 1 })
        anim.to(this.vitreMaterialblack.uniforms.u_fog, { value: -2, duration: 1 })
        anim.to(this.roadMaterial.uniforms.u_fog, {
            value: -2, duration: 1, onComplete: () => {

                // Supprimer les sous-composants s'ils ont une méthode destroy()
                this.batiments?.destroy?.()
                this.road?.destroy?.()

                // Nettoyer les matériaux
                if (this.materials) {
                    Object.values(this.materials).forEach(mat => {
                        if (mat.dispose) mat.dispose();
                    });
                }

                // Supprimer les références
                this.batiments = null
                this.road = null
                this.materials = null
                this.scene = null
                this.ressources = null
                this.experience = null
                this.targetPos = null
                this.time = null
                // 
                this.isDestroyed = true
            }
        })


    }




    update() {
        if (this.experience && this.experience.world) {
            this.targetX = this.experience.world.targetX
        }

        if (this.newPos && this.targetPos) {
            this.newPos.x = this.targetPos.x;
        }

        if (this.batiments) {
            this.batiments.update()

        }
        if (this.road) {
            this.road.update()

        }


    }
}